export default __webpack_public_path__ + "static/media/bronce.bb403a00.svg";